const UserIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 3.125C7.59033 3.125 5.625 5.09033 5.625 7.5C5.625 9.00635 6.39404 10.3442 7.55859 11.1328C5.32959 12.0898 3.75 14.3018 3.75 16.875H5C5 14.1064 7.23145 11.875 10 11.875C12.7686 11.875 15 14.1064 15 16.875H16.25C16.25 14.3018 14.6704 12.0898 12.4414 11.1328C13.606 10.3442 14.375 9.00635 14.375 7.5C14.375 5.09033 12.4097 3.125 10 3.125ZM10 4.375C11.7334 4.375 13.125 5.7666 13.125 7.5C13.125 9.2334 11.7334 10.625 10 10.625C8.2666 10.625 6.875 9.2334 6.875 7.5C6.875 5.7666 8.2666 4.375 10 4.375Z"
        fill="black"
      />
    </svg>
  )
}

export default UserIcon
